import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

import SwitchFilterSimGolf from './switch_filter_sim_golf'
import ViewFilterSimGolf from './view_filter_sim_golf'

const AdvancedFiltersSimGolf = (
  {
    disabled,
    onChange,
    open,
    eventsFound,
    setListView,
    setCalendarView,
    setIsChecked,
    viewType
  }) => {
  const handleChange = () => {
    if (!disabled) {
      onChange('advancedFiltersOn', !open)
    }
  }

  let label_name = open ?
    window.I18n.t('customer_directories.filters.sim_golf_advanced_filter_hide') :
    window.I18n.t('customer_directories.filters.sim_golf_advanced_filter')

  return (
    <div className='advanced_filters_sim_golf'>
      <div onClick ={ handleChange }>
        <Col>
          <img src={ require('bars_filter.svg') } />
        </Col>
      </div>
      <div className='filter_label'>
        { !window.I18n ? '' : label_name }
      </div>
      <div className='events_found'>
        { eventsFound } events found
      </div>
      <span className='appearance_filters'>
        <SwitchFilterSimGolf
          switchFor='category'
          isChecked={ viewType === 'category' }
          setIsChecked={ setIsChecked }
          onChange={ onChange }
          checkedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.show_by_category') }
          uncheckedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.show_by_category') }
        />
        <ViewFilterSimGolf
          onChange={ onChange }
          setListView={ setListView }
          setCalendarView={ setCalendarView }
          listView={ viewType === 'list' }
          calendarView={ viewType === 'calendar' }
        />
      </span>
    </div>
  )
}

AdvancedFiltersSimGolf.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  eventsFound: PropTypes.number.isRequired,
  setListView: PropTypes.func.isRequired,
  setCalendarView: PropTypes.func.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  viewType: PropTypes.string,
}

export default AdvancedFiltersSimGolf